import { ONLINE_STATUS } from "@/react/components/constants";
import type { ChatRoomParticipant } from "@/react/types/Chat/ChatRoomParticipant";

export const sortParticipants = (participants: ChatRoomParticipant[] = []) => {
  const moderators: ChatRoomParticipant[] = [];
  const nonModerators: ChatRoomParticipant[] = [];
  participants.forEach(participant => {
    if (participant.admin) {
      moderators.push(participant);
    } else {
      nonModerators.push(participant);
    }
  });
  return [...moderators, ...nonModerators];
};

export const mapParticipantsPerStatus = (
  participants: ChatRoomParticipant[],
) => {
  const onlineParticipants: ChatRoomParticipant[] = [];
  const offlineParticipants: ChatRoomParticipant[] = [];
  const idleParticipants: ChatRoomParticipant[] = [];

  participants
    .filter(({ deleted_at }) => !deleted_at)
    .forEach(participant => {
      if (participant.status === ONLINE_STATUS["online"]) {
        onlineParticipants.push(participant);
      } else if (participant.status === ONLINE_STATUS["idle"]) {
        idleParticipants.push(participant);
      } else {
        offlineParticipants.push(participant);
      }
    });

  return {
    onlineParticipants: [...onlineParticipants, ...idleParticipants],
    offlineParticipants,
  };
};
